// First Render animation handled with sessionStorage
function firstRenderAnimation() {
	let mainContent = document.getElementById("page");
	let loader = document.getElementById("home-loader");

	if (sessionStorage.getItem("firstRenderLoader") == "rendered") {
		loader.classList.remove("d-block");
		loader.classList.add("d-none");
		mainContent.classList.add("loaded");
	} else {
		loader.classList.add("d-block");
		window.onload = (event) => {
			mainContent.classList.add("loaded");
			loader.classList.add("close");
		};

		sessionStorage.setItem("firstRenderLoader", "rendered");
	}
}

firstRenderAnimation();
// End of First Render

function isVisible(changes, observer) {
	changes.forEach((change) => {
		if (change.intersectionRatio > 0) {
			if (change.target.classList.contains("odometer")) {
				triggerOdometer(change.target);
			} else {
				triggerAnimation(change.target);
			}

			observer.unobserve(change.target);
		}
	});
}

function triggerAnimation(el) {
	el.classList.add("triggerAnimation");

	if (el.classList.contains("delete-delay")) {
		setTimeout(function () {
			el.classList.add("no-delay");
		}, 1750);
	}
}

function triggerOdometer(el) {
	el.classList.add("odometer-animating-up", "odometer-animating");
}

var options = {
	root: null,
	rootMargin: "0px",
	threshold: 0.5,
};

var observer = new IntersectionObserver(isVisible, options);

// Only observe if elements exists

var homeMap = document.getElementById("home-map");
if (document.body.contains(homeMap)) {
	observer.observe(homeMap);
}

var videoTrigger = document.getElementById("videoModalButton__svg");
if (document.body.contains(videoTrigger)) {
	observer.observe(videoTrigger);
}

var svgPentagon = document.getElementById("pentagonal-services");
if (document.body.contains(svgPentagon)) {
	observer.observe(svgPentagon);
}

var odometers = document.getElementsByClassName("odometer");
if (odometers.length > 0) {
	for (let odometer of odometers) {
		observer.observe(odometer);
	}
}

var fadeUps = document.getElementsByClassName("fade-in-up");
if (fadeUps.length > 0) {
	for (let fadeUp of fadeUps) {
		observer.observe(fadeUp);
	}
}

var revealUps = document.getElementsByClassName("reveal-in-up");
if (revealUps.length > 0) {
	for (let revealUp of revealUps) {
		observer.observe(revealUp);
	}
}

var scaleDowns = document.getElementsByClassName("scale-down-in");
if (scaleDowns.length > 0) {
	for (let scaleDown of scaleDowns) {
		observer.observe(scaleDown);
	}
}

jQuery(document).ready(function ($) {
	$("#ms-main").click(function () {
		var topNav = $("nav#site-navigation");
		if (!topNav.hasClass("show-main")) {
			topNav.addClass("show-main");
		} else if (topNav.hasClass("show-main")) {
			topNav.removeClass("show-main");
		}

		if (topNav.hasClass("show-lang")) {
			topNav.removeClass("show-lang");
		}

		if (!$(this).hasClass("opened")) {
			$("#ms-langs").removeAttr("data-target");
			$("#ms-langs").removeData("target");
		} else {
			$("#ms-langs").attr("data-target", "#top-nav");
			$("#ms-langs").data("target", "#top-nav");
			$(this).attr("data-target", "#top-nav");
			$(this).data("target", "#top-nav");
		}

		$(this).toggleClass("opened");
		if ($("#ms-langs").hasClass("opened")) {
			$("#ms-langs").removeClass("opened");
			$("#menu-language-inner").removeClass("show");
		}
	});

	$("#ms-langs").click(function () {
		var topNav = $("nav#site-navigation");
		if (!topNav.hasClass("show-lang")) {
			topNav.addClass("show-lang");
			$("#menu-language-inner").addClass("show");
		}

		if (topNav.hasClass("show-main")) {
			topNav.removeClass("show-main");
		}

		if (!$(this).hasClass("opened")) {
			$("#ms-main").removeAttr("data-target");
			$("#ms-main").removeData("target");
		} else {
			$("#ms-main").attr("data-target", "#top-nav");
			$("#ms-main").data("target", "#top-nav");
			$(this).attr("data-target", "#top-nav");
			$(this).data("target", "#top-nav");
		}

		$(this).toggleClass("opened");
		if ($("#ms-main").hasClass("opened")) {
			$("#ms-main").removeClass("opened");
		}
	});

	$("ul.nav li.dropdown").hover(
		function () {
			$(this).find(".dropdown-menu").stop(true, true).delay(200).fadeIn(100);
		},
		function () {
			$(this).find(".dropdown-menu").stop(true, true).delay(200).fadeOut(100);
		}
	);

	//Sub Services Accordion
	$("#services-list a").click(function (e) {
		e.preventDefault();
		let id = $(this).attr("href");
		let target = $(id);

		if (target.length) {
			var top = target.position().top;
			$("#services-content").animate({ scrollTop: $("#services-content").scrollTop() + top }, 1000);
			return false;
		}
	});

	$("#services-accordion").on("hide.bs.collapse", (e) => {
		let service_id = jQuery(e.target).data("heading");
		$("#heading-" + service_id).removeClass("active");
	});

	$("#services-accordion").on("show.bs.collapse", (e) => {
		let service_id = jQuery(e.target).data("heading");
		$("#heading-" + service_id).addClass("active");
	});

	// FWP radio button tabs

	$("div#toggle-reset").click(function () {
		FWP.reset();
		if (!$(this).hasClass("checked")) {
			$(this).addClass("checked");
		}
	});

	$("div.facetwp-facet-portfolio_filters").click(function () {
		$("div#toggle-reset").removeClass("checked");
	});

	$(window).scroll(() => {
		var scrollDistance = $(window).scrollTop();
		var header = $("header#masthead");
		if (scrollDistance === 0) {
			if (header.hasClass("sticky-nav")) {
				header.removeClass("sticky-nav");
			}
		} else {
			if (!header.hasClass("sticy-nav")) {
				header.addClass("sticky-nav");
			}
		}
	});

	// Mobile Dropdown (For tabs)
	$("a[data-trigger]").click(function () {
		if ($(this).attr("data-trigger") == "toggle-reset") {
			$("div#toggle-reset").trigger("click");
		} else {
			var myTrigger = $(this).attr("data-trigger");
			$(".facetwp-radio").each(function () {
				if (myTrigger === $(this).attr("data-value")) {
					$(this).trigger("click");
				}
			});
		}
	});

	//Client Logo Swap

	let interval;

	if (jQuery(".client-logo-swap.non-active").length) {
		let i = 0;
		let len = jQuery(".client-logo-swap.active").length;

		interval = setInterval(() => {
			let active = jQuery(".client-logo-swap.active");

			if (active.length === len) {
				let non_active = jQuery(".client-logo-swap.non-active");
				let randomLogoIndex = Math.floor(Math.random() * Math.floor(len));
				let targetLogo = jQuery(active[randomLogoIndex]);
				let newLogo = jQuery(non_active[i]);
				let targetClone = jQuery(targetLogo).clone();
				let newClone = jQuery(newLogo).clone();

				jQuery(newClone).removeClass("non-active").addClass("active");
				jQuery(targetClone).removeClass("active").addClass("non-active");

				jQuery(targetLogo).fadeOut(1500, () => {
					jQuery(targetLogo).replaceWith(newClone);
					jQuery(newLogo).replaceWith(targetClone);
					jQuery(newClone).hide();
					jQuery(newClone).fadeIn(1500, () => {
						jQuery(newClone).css("opacity", "");
					});
				});

				i >= non_active.length - 1 ? (i = 0) : i++;
			} else {
				clearInterval(interval);
			}
		}, 3000);
	} //END - Client Logo Swap

	//Language Change
	$(".language-top-choice").click(function () {
		$(this).toggleClass("show-children");
	});

	$(".dropdown-localization").click(function () {
		$("ul.custom-languages").toggleClass("show-list");
	});

	$("#mobile-globe").click(function () {
		$("#nested-switcher ul.custom-languages").toggleClass("show-list");
	});

	$(".expand-trigger").click(function () {
		$(".expandable").toggleClass("expanded");
	});

	$("#WMTS-carousel").on("slid.bs.carousel", () => {
		AOS.init();
	});

	//Custom bootstrap modal actions for Leadership Modal
	jQuery("#leadership-modal").on("show.bs.modal", (e) => {
		let leader_id = jQuery(e.relatedTarget).data("id");
		jQuery(".carousel-item").removeClass("active");
		jQuery('.carousel-item[data-id="' + leader_id + '"]').addClass("active");
	});

	//
	jQuery("#top-nav .menu-item-has-children").on("touchend", (e) => {
		jQuery(e.currentTarget).toggleClass("touched");
	});
});

jQuery(window).on("load resize", () => {
	//Our services. Adjust service name height
	let service_names = jQuery(".service-content").find(".service-name");

	jQuery(service_names).css("height", "auto");

	if (service_names.length) {
		let height = 0;
		for (let i = 0; i < service_names.length; i++) {
			let el_height = jQuery(service_names[i]).height();
			if (el_height > height) {
				height = el_height;
			}
		}
		if (height > 0) {
			jQuery(service_names).height(height);
		}
	}
});

jQuery(document).on("gform_post_render", () => {
	function click_file_field(e) {
		jQuery("input#input_" + e.data.formNumber).trigger("click");
	}

	jQuery("a#pseudo, a#pseudo2").unbind("click");
	jQuery("a#pseudo, a#pseudo2").attr({
    role: "button",
    tabindex: "0",
  });

	jQuery("a#pseudo").on("click", { formNumber: "3_5" }, click_file_field);
	jQuery("a#pseudo2").on("click", { formNumber: "2_5" }, click_file_field);
});

jQuery("input#input_2_5, input#input_3_5").on("change", (e) => {
	let filefields = jQuery(e.target);
	if (filefields.length) {
		jQuery("span.ps-content").text(filefields[0].files[0].name);
	}
});

var getUrlParameter = function getUrlParameter(sParam) {
	var sPageURL = window.location.search.substring(1),
		sURLVariables = sPageURL.split("&"),
		sParameterName,
		i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split("=");

		if (sParameterName[0] === sParam) {
			return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
		}
	}
};

//Close nav if click outside #masthead or cookie
jQuery(document).on("click touchend", function (event) {
	if (
		jQuery(event.target).closest("#masthead").length > 0 &&
		jQuery(event.target).closest(".cc-message").length > 0 &&
		jQuery(event.target).closest(".cc-btn.cc-dismiss").length > 0
	) {
		jQuery("#top-nav").collapse("hide");
		jQuery("#site-navigation").removeClass("show-main");
		jQuery("#ms-main").removeClass("opened collapsed");
	}
});

jQuery("#videoModal")
	.on("shown.bs.modal", (e) => {
		let $videoSource = jQuery(".video-btn").data("src");
		jQuery("#heroVideo").get(0).pause();
		jQuery("#video").attr("src", $videoSource);

		let param = { our_story: 1 };
		let params = jQuery.param(param);
		window.history.pushState({}, document.title, "?" + params);
	})
	.on("hidden.bs.modal", (e) => {
		jQuery("#heroVideo").get(0).play();
		jQuery("#video").attr("src", "");
		window.history.replaceState({}, document.title, "/");
	});

jQuery(document).ready(() => {
	if (jQuery("#videoModal").data("show")) {
		jQuery("#videoModalButton").click();
	}
});

// jQuery('#languageModal').on('hidden.bs.modal', (e) => {
//     let parsedUrl = new URL(window.location.href);
//
//     if(parsedUrl.searchParams.get('our_story') && !jQuery('#videoModal').is(':visible')){
//         jQuery('#videoModalButton').click();
//     }
// });

jQuery(document).ready(function ($) {
	let fwpFilter = getUrlParameter("fwp_portfolio_filters");

	if (fwpFilter) {
		let filteredFWPFilter = fwpFilter.substring(0, fwpFilter.indexOf("-"));

		if (filteredFWPFilter) {
			console.log(filteredFWPFilter);
		}
	}
	$(".facetwp-radio-clone").click(function () {
		$(".facetwp-radio-clone").each(function () {
			if ($(this).hasClass("checked")) {
				$(this).removeClass("checked");
			}
		});
		$(this).addClass("checked");

		let cloned = $(this).attr("data-clone");

		if (cloned === "all") {
			console.log(cloned);
			$("#toggle-reset").trigger("click");
		} else {
			$(`[data-value^="${cloned}"]`).trigger("click");
		}
	});
});

jQuery(document).ready(function ($) {
	var theLanguage = $("html")[0].lang;
	$("li.menu-item").each(function () {
		var thisLanguage = $(this).attr("data-hreflang");
		if (thisLanguage === theLanguage) {
			$(this).addClass("active");
			$(this).find("a").addClass("active");
		}
	});
});

// Pentagonal Services functionality
jQuery(document).ready(function ($) {
	if ($("#pentagonal-services").length) {
		var svg = $("#servicesSVG");

		$(document).on("click touchleave", function (e) {
			if ($(e.target).is("#pentagonal-services svg") === false) {
				var svg = $("#servicesSVG");
				if (svg.attr("class") != undefined) {
					svg.removeAttr("class");
				}
			}
		});
	}

	var heroVideo = $("#heroVideo")[0];

	if (heroVideo) {
		var scroll = $(window).scrollTop();
		// check scroll position when document is ready
		scroll > 200 ? heroVideo.pause() : heroVideo.play();
		// check scroll position when scroll is fired
		$(window).scroll(function () {
			scroll = $(this).scrollTop();
			scroll > 200 ? heroVideo.pause() : heroVideo.play();
		});
	}
});

// Sub Services Accordion
jQuery(function ($) {
	let accordion = $("[id^=servicesAccordion]");

	accordion.on("show.bs.collapse	", (e) => {
		$(e.target).prev(".card-header").find(".btn").attr("aria-expanded", "true");
	});
	accordion.on("shown.bs.collapse	", (e) => {
		$(e.target).prev(".card-header").find(".btn").attr("aria-expanded", "true");
	});
	accordion.on("hide.bs.collapse	", (e) => {
		$(e.target).prev(".card-header").find(".btn").attr("aria-expanded", "false");
	});
	accordion.on("hidden.bs.collapse	", (e) => {
		$(e.target).prev(".card-header").find(".btn").attr("aria-expanded", "false");
	});
});

// Persist utm parameter in navigation
jQuery(document).ready(function () {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);

	const source = urlParams.get("utm_source");
	const medium = urlParams.get("utm_medium");
	const campaign = urlParams.get("utm_campaign");
	const term = urlParams.get("utm_term");

	let utmInheritingDomain = window.location.hostname, // REPLACE THIS DOMAIN (DO NOT INCLUDE HTTPS)
		utmRegExp = /(\&|\?)utm_[A-Za-z]+=[A-Za-z0-9]+/gi,
		links = jQuery("a").not("svg a"),
		utms = [];

	source && utms.push(`utm_source=${source}`);
	medium && utms.push(`utm_medium=${medium}`);
	campaign && utms.push(`utm_campaign=${campaign}`);
	term && utms.push(`utm_term=${term}`);

	if (utms.length > 0) {
		for (let index = 0; index < links.length; index += 1) {
			let tempLink = links[index].href,
				tempParts;

			if (tempLink.indexOf(utmInheritingDomain) > 0) {
				// The script is looking for all links with the utmInheritingDomain
				tempLink = tempLink.replace(utmRegExp, "");

				tempParts = tempLink.split("#");

				if (tempParts[0].indexOf("?") < 0) {
					tempParts[0] += "?" + utms.join("&"); // The script adds UTM parameters to all links with the domain you've defined
				} else {
					tempParts[0] += "&" + utms.join("&");
				}

				tempLink = tempParts.join("#");
			}

			links[index].href = tempLink;
		}
	}
});

if (jQuery("svg").length > 0) {
	jQuery("svg").ready(function () {
		let links = jQuery("svg a");
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);

		const source = urlParams.get("utm_source");
		const medium = urlParams.get("utm_medium");
		const campaign = urlParams.get("utm_campaign");
		const term = urlParams.get("utm_term");

		let utmInheritingDomain = window.location.hostname, // REPLACE THIS DOMAIN (DO NOT INCLUDE HTTPS)
			utmRegExp = /(\&|\?)utm_[A-Za-z]+=[A-Za-z0-9]+/gi,
			utms = [];

		source && utms.push(`utm_source=${source}`);
		medium && utms.push(`utm_medium=${medium}`);
		campaign && utms.push(`utm_campaign=${campaign}`);
		term && utms.push(`utm_term=${term}`);

		if (utms.length > 0) {
			for (let index = 0; index < links.length; index += 1) {
				let tempLink = jQuery(links[index]).attr("href"),
					tempParts;

				if (tempLink.indexOf(utmInheritingDomain) > 0) {
					// The script is looking for all links with the utmInheritingDomain
					tempLink = tempLink.replace(utmRegExp, "");

					tempParts = tempLink.split("#");

					if (tempParts[0].indexOf("?") < 0) {
						tempParts[0] += "?" + utms.join("&"); // The script adds UTM parameters to all links with the domain you've defined
					} else {
						tempParts[0] += "&" + utms.join("&");
					}

					tempLink = tempParts.join("#");
				}

				jQuery(links[index]).attr("href", tempLink);
			}
		}
	});
}
